import SmartAnalyticsCandidateComponent from '../Components/SmartAnalytics/SmartAnalyticsCandidateComponent';

function SmartAnalyticsCandidatePage() {
  return <SmartAnalyticsCandidateComponent />;
}

export default SmartAnalyticsCandidatePage;